import S3 from "../../../../contents/docs/cdp/sources/_snippets/source-s3.mdx";
import * as React from 'react';
export default {
  S3,
  React
};